import {apiService} from '../common/apiCallService';
import {baseUrl} from '../common/config.js';
import moment from 'moment';
import AuthenticateUser from '../components/AuthenticateUser'
import { Redirect } from 'react-router';
import React from 'react';

export function updateOnBoard() {
  apiService(`${baseUrl}/appuser/updateOnBoard`,
    {
      userType: localStorage.getItem("loggedInType"),
      accountName: localStorage.getItem("accountName"),
    },
    (data) => {
      if (data === 'Updated')
        localStorage.setItem("mygame_onboarded", 'Y')
      return data
    }, (error) => {
      this.setState({ loading: false })
      console.log("Error:", error)
    })
}

export function getCurrencySymbol(currency) {
  console.log("getCurrencySymbol..........", currency)
  const currenciesList = [
    { key: 'USD', code: '\u0024' },
    { key: 'EUR', code: '\u20AC' },
    { key: 'GBP', code: '\u00A3' },
    { key: 'CAD', code: ('\u0043').concat('\u0024') },
    { key: 'RUB', code: '\u20BD' },
    { key: 'DKK', code: ('\u004B').concat('\u0072').concat('\u002E') },
    { key: 'GEL', code: '\u20BE' }]

  let currencyObj = currenciesList.filter(obj => currency === obj.key)
  if (currencyObj.length > 0)
    return currencyObj[0].code
  else
    return '\u0024'
}

export function getFormattedDate(date) {
  var month = date.getMonth() + 1;
  month = (month<10?'0':'') + month
  var day = (date.getDate()<10?'0':'') + date.getDate();
  var year = date.getFullYear()
  var hour = (date.getHours()<10?'0':'') + date.getHours();
  var minute = (date.getMinutes()<10?'0':'') + date.getMinutes();
  var second = (date.getSeconds()<10?'0':'') + date.getSeconds();
  return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}

export function getFormattedTime(date) {
  var hour = (date.getHours()<10?'0':'') + date.getHours();
  var minute = (date.getMinutes()<10?'0':'') + date.getMinutes();
  var second = (date.getSeconds()<10?'0':'') + date.getSeconds();
  return hour + ":" + minute + ":" + second;
}

export function getCorlorCodForGrade(grade) {
  if(grade === 'A') return '#7ED321'
  if(grade === 'B') return '#7ED321'
  if(grade === 'C') return '#FFC814'
  if(grade === 'D') return '#FE8F40'
  if(grade === 'E') return '#FF4E3E'
}

function generateActivityToken() {
  if(!localStorage.getItem("activity_tracking_token") || localStorage.getItem("activity_tracking_token") == '') {
    apiService(baseUrl + '/appUser/generateActivityHitsToken', {}, (data) => {
      console.log(data);
      localStorage.setItem("activity_tracking_token", data.token)
    }, (err) => {
      console.log(err);
    })
  }
}
export const getWhiteLabelUIData = async (loggedInType) => new Promise((resolve, reject)=>{
  console.log("getWhiteLabelUIData loggedInType", loggedInType)
  apiService(baseUrl + "/whiteLabelUI/getWhiteLabelUIData",{ loggedInType }, (data) => {
    console.log("/whiteLabelUI/getWhiteLabelUIData::" ,JSON.stringify(data))
    if (data) {
      localStorage.setItem("whiteLabelUIData", JSON.stringify(data))
      resolve()
    } else {
      reject()
    }
  }, (err) => {
    localStorage.removeItem("whiteLabelUIData")
    console.log('getWhiteLabelUIData error', err);
    reject()
  })
})

export function saveActivity(activityObj){
  try {
    let activityTrack = [], actTrackStorage = []
    let track = {}
    track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    track.session_id = activityObj.session_id ? activityObj.session_id : localStorage.getItem("token")
    track.userid = activityObj.userid ? activityObj.userid : localStorage.getItem("username")
    track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
    track.hit_page = activityObj.hit_page
    track.hit_type = activityObj.hit_type
    track.hit_brand = localStorage.getItem('loggedInType')? localStorage.getItem('loggedInType') : "No brand",
    track.hit_attribute1 = activityObj.hit_attribute1 ? activityObj.hit_attribute1 : ''
    track.hit_attribute2 = activityObj.hit_attribute2 ? activityObj.hit_attribute2 : ''
    track.hit_attribute3 = activityObj.hit_attribute3 ? activityObj.hit_attribute3 : ''
    track.hit_attribute4 = activityObj.hit_attribute4 ? activityObj.hit_attribute4 : ''
    track.hit_attribute5 = activityObj.hit_attribute5 ? activityObj.hit_attribute5 : ''
    track.hit_player = activityObj.hit_player ? activityObj.hit_player : (localStorage.getItem("accountName") ? localStorage.getItem("accountName") :  "No accountName")
    activityTrack.push(track)
    
    if(localStorage.getItem('activityTrack'))  
      actTrackStorage = JSON.parse(localStorage.getItem('activityTrack'))
      if(actTrackStorage && actTrackStorage.length > 0) {
        actTrackStorage = actTrackStorage.map(obj => ({ ...obj, hit_brand: localStorage.getItem('loggedInType') || "No brand",
        hit_player: activityObj.hit_player || localStorage.getItem("accountName") || "No accountName" })); 
        activityTrack = [...activityTrack, ...actTrackStorage]
      }

    console.log("track.hit_page==="+track.hit_page)
    if(track.hit_page != 'Tracking Tag' && (!localStorage.getItem("activity_tracking_token") || localStorage.getItem("activity_tracking_token") == '')) {
      console.log("====inside if=======")
     // if(actTrackStorage && actTrackStorage.length > 0) activityTrack = [...activityTrack, ...actTrackStorage]
      localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
      generateActivityToken()
      return
    }

    if(actTrackStorage && actTrackStorage.length > 0) {
     // activityTrack = [...activityTrack, ...actTrackStorage]
      localStorage.removeItem('activityTrack');
    }
    console.log("activityTrack", activityTrack)
    apiService(baseUrl + '/activitytracking', {
      activityTrack, activity_tracking_token: localStorage.getItem("activity_tracking_token")
    }, (data) => {
      console.log(data);
      if(data && data.activity_tracking_token) {
        localStorage.setItem("activity_tracking_token", data.activity_tracking_token)
      }
    }, (err) => {
      console.log(err);
    })
  } catch (error) {
    console.log(error)
    throw new Error(error)
  }
}

exports.processHoleCards = (plydata, hands, selectedType, position) => new Promise(function (resolve, reject) {
  console.log("plydata============>",plydata, hands, selectedType, position);
  let playerData = [],
    handCardData = [],
    handCount = { Early: { played: 0, notPlayed: 0, progressplayed: 0 }, Mid: { played: 0, notPlayed: 0, progressplayed: 0 }, Late: { played: 0, notPlayed: 0, progressplayed: 0 } },
    uniquePlydata = Array.from(new Set(plydata.map(JSON.stringify))).map(JSON.parse)
  uniquePlydata.map((obj) => {
   let data = {
      playerPosition: obj.position == "Mid" ? "Early" : obj.position ,
      cards: obj.cards,
      gameNo: obj.gameNo
    }
    playerData.push(data)
    if (hands[obj.position].hasOwnProperty(obj.cards)) {
      
      if (hands[obj.position][obj.cards] == 'Yes')
        handCount[obj.position].played = handCount[obj.position].played + 1
      else if (hands[obj.position][obj.cards] == 'No')
        handCount[obj.position].notPlayed = handCount[obj.position].notPlayed + 1
    }
  })
  handCardData = []
  handCardData = playerData.reduce((acc, obj) => {
    if (obj.playerPosition == position) acc.push(obj)
    return acc
  }, [])
  resolve([handCount, handCardData, playerData])
})

export function saveUserTracking(trackingObj){
  apiService(baseUrl + '/appUser/tracking', {...trackingObj
  }, (data) => {
    console.log(data);
  }, (err) => {
    console.log(err);
  })
}

export function createVirtualPageLoad(pageName) {
  if (window.sessionCamRecorder) {
      if (window.sessionCamRecorder.createVirtualPageLoad)
          window.sessionCamRecorder.createVirtualPageLoad(pageName);
  }
}
  
export function closeVirtualPage() {
  if (window.sessionCamRecorder && window.sessionCamRecorder.closeVirtualPage) {
      window.sessionCamRecorder.closeVirtualPage();
  }
}

export function customDataObjects(key,value) {
  if (!window.sessioncamConfiguration)
    window.sessioncamConfiguration = new Object();
  if (!window.sessioncamConfiguration.customDataObjects)
    window.sessioncamConfiguration.customDataObjects = [];
  var item = { key: key, value: value };
  window.sessioncamConfiguration.customDataObjects.push(item);
}


export function getCoins(amount,highEndChips,lowEndChips){
  let finalChips = [];
  if(amount){
  let beforeDec = parseInt(amount.toString().split('.')[0]);
  let afterDec = parseFloat("0." + amount.toString().split('.')[1]);
  let index = 0;

  if (beforeDec > 0) {
    highEndChips.map((chip) => {
      if (beforeDec >= chip) {
        let temp = {};
        temp[index] = [];
        let remChips = beforeDec % chip;
        let pokerChip;
        if (remChips == 0) {
          pokerChip = beforeDec / chip;
          beforeDec = 0;
        } else {
          pokerChip = beforeDec - remChips;
          pokerChip = pokerChip / chip;
          beforeDec = remChips;
        }
        let i = 0;
        while (i < pokerChip) {
          temp[index].push(chip);
          i++;
        }
        finalChips.push(temp);
        index++;
      }
    });
  }

  if (afterDec > 0) {
    lowEndChips.map((chip) => {
      if (afterDec >= chip) {
        let temp = {};
        temp[index] = [];
        let remChips = afterDec % chip;
        let pokerChip;
        if (remChips == 0) {
          pokerChip = afterDec / chip;
          afterDec = 0;
        } else {
          remChips = remChips.toFixed(2);
          remChips = parseFloat('0.' + remChips.toString().split('.')[1].substring(0, 2));
          pokerChip = afterDec - remChips;
          pokerChip = pokerChip / chip;
          pokerChip = pokerChip.toFixed(2);
          afterDec = remChips;
        }
        let i = 0;
        while (i < pokerChip) {
          temp[index].push(chip);
          i++;
        }
        finalChips.push(temp);
        index++;
      }
    });
  }}
  return finalChips;
}

export function generateCardLinks(cards) {
  let imgUrls = [];
  let typeOfCards = ["club", "diamond", "heart", "spade"];
  for (let card of cards) {
    let cardName = typeOfCards.find(
      type => type.indexOf(card[card.length - 1]) > -1
    );
    cardName = "/images/cards1x/" + cardName + "/" + card.replace(/ /g,'') + ".png";
    imgUrls.push(cardName);
  }
  return imgUrls;
}

export function logoutActivityTrack (){
  try {
    // await this.props.resetStore()
    document.body.style.backgroundColor = "#1F1E23";
    let activityTrack = []
    let track = {}
    // if (localStorage.getItem('activityTrack'))
    //   activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
    track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      track.session_id = localStorage.getItem("token")
    track.userid = localStorage.getItem("username")
    track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
    track.hit_page = 'Logout'
    track.hit_type = 'Logout'
    track.hit_brand = localStorage.getItem('loggedInType')? localStorage.getItem('loggedInType') : "No brand"
    track.hit_attribute1 = 'success'
    if (localStorage.getItem('userRole') && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') !== -1) {
      track.hit_attribute2 = localStorage.getItem("first_name")
      track.hit_attribute3 = localStorage.getItem("last_name")
      track.hit_attribute4 = localStorage.getItem("alias")
      track.hit_player = localStorage.getItem("accountName") ? localStorage.getItem("accountName") :  "No accountName"
    } else {
      track.hit_attribute2 = ''
      track.hit_attribute3 = ''
      track.hit_attribute4 = ''
    }
    track.hit_attribute5 = ''
    track.hit_player = localStorage.getItem("accountName") ? localStorage.getItem("accountName") :  "No accountName"
    // activityTrack.push(track)
    // localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
    // if (localStorage.getItem('token') && localStorage.getItem('activityTrack')) {
    //   let activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
    //   localStorage.removeItem('activityTrack');
      saveActivity(track)
    // }
    const loginPath = localStorage.getItem('loggedInType')
    localStorage.clear()
    AuthenticateUser.isAuthenticated = false
  } catch (error) {
    // this.props.resetStore()
    let activityTrack = []
    let track = {}
    // if (localStorage.getItem('activityTrack'))
    //   activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
    track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      track.session_id = localStorage.getItem("token")
    track.userid = localStorage.getItem("username")
    track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
    track.hit_page = 'Logout'
    track.hit_type = 'Logout'
    track.hit_brand = localStorage.getItem('loggedInType')? localStorage.getItem('loggedInType') : "No brand"
    track.hit_attribute1 = 'fail'
    if (localStorage.getItem('userRole') && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') !== -1) {
      track.hit_attribute2 = localStorage.getItem("first_name")
      track.hit_attribute3 = localStorage.getItem("last_name")
      track.hit_attribute4 = localStorage.getItem("alias")
      track.hit_player = localStorage.getItem("accountName") ? localStorage.getItem("accountName") :  "No accountName"
    } else {
      track.hit_attribute2 = ''
      track.hit_attribute3 = ''
      track.hit_attribute4 = ''
    }
    track.hit_attribute5 = ''
    track.hit_player = localStorage.getItem("accountName") ? localStorage.getItem("accountName") :  "No accountName"
    // activityTrack.push(track)
    // localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
    // if (localStorage.getItem('token') && localStorage.getItem('activityTrack')) {
    //   let activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
    //   localStorage.removeItem('activityTrack');
      saveActivity(track)
    // }
    throw new Error(error)
  }
}

export function trackSid(sId, path) {
  saveActivity({
    hit_page: 'Tracking Tag',
    hit_type: 'Tracking Tag',
    hit_attribute1: sId,
    hit_attribute3: path,
    hit_brand : localStorage.getItem('loggedInType')? localStorage.getItem('loggedInType') : "No brand",
    userid: localStorage.getItem('username') ? localStorage.getItem('username') : getTrackId(),
    session_id: localStorage.getItem('token') ? localStorage.getItem('token') : 'anonymous',
    hit_player: localStorage.getItem("accountName") ? localStorage.getItem("accountName") :  "No accountName"
  })
}

export function getTrackId() {
  const trackerId = localStorage.getItem('trackerId');
  if (trackerId) {
    return trackerId;
  } else {
    var newTrackerId = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 15; i++)
      newTrackerId += possible.charAt(Math.floor(Math.random() * possible.length));
    localStorage.setItem('trackerId', newTrackerId);
    return newTrackerId;
  }
}


/** WEBPACK FOOTER **
 ** ./src/common/commonService.js
 **/